import { API_ENDPOINTS } from '../constants';

class SmsParserService {
  constructor() {
    this.apiKey = process.env.REACT_APP_SMS_PARSER_API_KEY || '';
    this.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
  }

  getHeaders() {
    const headers = {
      'Content-Type': 'application/json',
    };

    if (this.apiKey) {
      headers['X-SMS-Parser-API-Key'] = this.apiKey;
    }

    return headers;
  }

  async fetchWithAuth(url, options = {}) {
    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          ...this.getHeaders(),
          ...options.headers,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('SMS Parser API Error:', {
          status: response.status,
          statusText: response.statusText,
          data: data
        });
        throw new Error(data.message || `Request failed with status ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('SMS Parser API Request Error:', error);
      throw error;
    }
  }

  async getResponses(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.phoneNumber && params.phoneNumber.trim()) {
      queryParams.append('phoneNumber', params.phoneNumber.trim());
    }
    if (params.endpoint) queryParams.append('endpoint', params.endpoint);
    if (params.isSuccess !== undefined && params.isSuccess !== '') {
      queryParams.append('isSuccess', params.isSuccess);
    }
    if (params.statusCode) queryParams.append('statusCode', params.statusCode);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);

    const queryString = queryParams.toString();
    const url = `${this.baseURL}${API_ENDPOINTS.SMS_PARSER.RESPONSES}${queryString ? '?' + queryString : ''}`;
    
    console.log('SMS Parser API Request URL:', url);
    console.log('SMS Parser API Headers:', this.getHeaders());
    
    return this.fetchWithAuth(url);
  }

  async getResponseById(id) {
    const url = `${this.baseURL}${API_ENDPOINTS.SMS_PARSER.RESPONSE_BY_ID(id)}`;
    return this.fetchWithAuth(url);
  }

  async deleteResponse(id) {
    const url = `${this.baseURL}${API_ENDPOINTS.SMS_PARSER.DELETE_RESPONSE(id)}`;
    return this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }

  async deleteMultipleResponses(criteria) {
    const url = `${this.baseURL}${API_ENDPOINTS.SMS_PARSER.RESPONSES}`;
    return this.fetchWithAuth(url, {
      method: 'DELETE',
      body: JSON.stringify(criteria),
    });
  }

  async cleanupResponses(days) {
    const url = `${this.baseURL}/sms-parser/responses/cleanup`;
    return this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ days }),
    });
  }
}

export default new SmsParserService();

